import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IBurgerMenuItem } from 'API/Home/burgerMenuItems';

export interface IBurgerMenuState {
  menuItems: IBurgerMenuItem[];
  isBurgerMenuOpen: boolean;
}

const initialState: IBurgerMenuState = {
  menuItems: [],
  isBurgerMenuOpen: false,
};

export const menuItemsSlice = createSlice({
  name: 'menu-items',
  initialState,
  reducers: {
    setMenuItems: (
      state: IBurgerMenuState,
      action: PayloadAction<IBurgerMenuState | any>
    ) => {
      state.menuItems = action.payload;
    },
    setBurgerMenuOpen: (state, action: PayloadAction<boolean>) => {
      state.isBurgerMenuOpen = action.payload;
    },
  },
});

export const { setMenuItems, setBurgerMenuOpen } = menuItemsSlice.actions;
export default menuItemsSlice.reducer;
